module.exports = function(posts) {
	'use strict'
	posts.directive('allPostsDir',allPostsDir);
	allPostsDir.$inject=[];
	function allPostsDir() {
		return {
			template: require('./partial/allposts.html'),
			controller:'allpostsController',
			controllerAs:'vmap',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/allposts/js/directive/allpostsDirective.js
// module id = 549
// module chunks = 0